import React from 'react';
import { Route, IndexRoute } from 'react-router';
import GeneralActions from './actionsGeneral';

export default (
  <Route path="minhas-atividades">
    <IndexRoute component={(props) => <GeneralActions {...props} />} />
  </Route>
);
